import ExportCreatives from './ExportCreatives';

const ExportCreativesDirective = (
  reactDirective,
  AdMarkupService,
  CreativeService,
  CreativeGroupService,
  FlashService,
  MixpanelService
) => {
  return reactDirective(
    ExportCreatives,
    undefined,
    { restrict: 'E' },
    { AdMarkupService, CreativeService, CreativeGroupService, FlashService, MixpanelService }
  );
};
ExportCreativesDirective.$inject = [
  'reactDirective',
  'AdMarkupService',
  'CreativeService',
  'CreativeGroupService',
  'FlashService',
  'MixpanelService'
];

export default ExportCreativesDirective;
